import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { songs } from "../../database/song";
import Layout from "../Layout";
import MusicPlayer from "../MusicPlayer";
import SongCard from "../SongCard";
import {
  RiPlayMiniFill,
  RiHeartLine,
  RiMoreFill,
  RiTimeLine,
  RiPauseMiniLine,
} from "react-icons/ri";
import { connect } from "react-redux";
import { changePlayPause, changeTrack } from "../../actions";

function SongDescription(props) {
  const { data_id } = useParams();

  const [data, setData] = useState([]);

  const [heart, setHeart] = useState(false);
  const { title, movie, thumbnail, singer, year } = data;

  useEffect(() => {
    getDataFromDb();
  }, [data_id, props.isPlaying]);

  const getDataFromDb = async () => {
    let songIndex = songs.filter((data) => data._id == data_id);
    await setData(songIndex[0]);
  };

  const checkRoute = (type) => {
    if (type == "song") {
      return "/album/";
    } else if (type == "podcast") {
      return "/shows/";
    }
  };

  return (
    <>
      <Layout />
      <div className="pl-60  w-screen " style={{}}>
        <div
          className="w-screen h-[600px] pt-16 p-4 flex"
          style={{
            backgroundImage: `linear-gradient(${data.bgGradient})`,
          }}
        >
          <div className="h-72 flex items-center pb-10 p-4">
            <div
              className="w-56 h-56 bg-white shadow-lg mr-6"
              style={{
                boxShadow: "0 0 25px -10px black",
                borderRadius: 4,
                backgroundImage: `url(${thumbnail && thumbnail})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                borderRadius: 4,
              }}
            ></div>
            <div className="flex flex-col mt-16">
              <p className="text-white text-sm">{movie && movie}</p>
              <h1 className="text-white text-[80px] m-0 font-bold">{title}</h1>
              <p className="text-white text-sm">
                {singer} <span> | {data.year}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="w-[100%] pb-40 bg-[#0000002c] -mt-60 pt-6 pl-10 pr-10 flex flex-col items-center  ">
          <div className="flex items-center w-[100%] ">
            <div>
              {!props.isPlaying && props.songData._id == data_id ? (
                <RiPauseMiniLine
                  onClick={() =>
                    props.songData._id == data_id
                      ? props.changePlayPause(!props.isPlaying)
                      : props.changeTrack(data_id)
                  }
                  className="text-black text-6xl p-2 mr-8 bg-green-500 rounded-full  box-border  hover:p-3 transition-all ease-in-out duration-200 cursor-pointer"
                />
              ) : (
                <RiPlayMiniFill
                  onClick={() =>
                    props.songData._id == data_id
                      ? props.changePlayPause(!props.isPlaying)
                      : props.changeTrack(data_id)
                  }
                  className="text-black text-6xl p-2 mr-8 bg-green-500 rounded-full  box-border  hover:p-3 transition-all ease-in-out duration-200 cursor-pointer"
                />
              )}
            </div>

            <RiHeartLine
              onClick={() => setHeart(!heart)}
              className={`text-white text-4xl  mr-8 opacity-30 ${
                heart && "opacity-100"
              } transition-all ease-in-out duration-200 cursor-pointer`}
            />
            <RiMoreFill className="text-white text-4xl   opacity-60 hover:opacity-100 transition-all ease-in-out duration-200 cursor-pointer" />
          </div>
          <div
            style={{
              marginTop: 30,
              width: "100%",
            }}
            className="border-b-2 pl-10  pr-10 p-2 border-b-neutral-600  flex items-center justify-between"
          >
            <p className="text-neutral-300 text-sm opacity-70   ">
              # <span className="ml-8">TITLE</span>
            </p>
            <RiTimeLine className="text-neutral-300 text-2xl opacity-70" />
          </div>

          <div
            style={{
              marginTop: 10,
              width: "100%",
            }}
          >
            <Link
              // to={`${data.type == "song" && "/album/"}`}
              to={`${checkRoute(data.type)}${data_id}`}
              onClick={() => props.changeTrack(data_id)}
              style={{
                width: "100%",
              }}
              className="flex flex-row items-center justify-between pl-6  pr-8 p-2 mb-2 hover:bg-[#ffffff20] cursor-pointer transition-all ease-in"
            >
              <div className="flex items-center">
                {!props.isPlaying && props.songData._id == data_id ? (
                  <img
                    onClick={() =>
                      props.songData._id == data_id
                        ? props.changePlayPause(!props.isPlaying)
                        : props.changeTrack(data_id)
                    }
                    style={{
                      width: 20,
                      height: 20,
                      marginLeft: 12,
                    }}
                    className={`${
                      !props.isPlaying &&
                      props.songData._id == data_id &&
                      "text-green-600"
                    }  text-white text-[6px] ml-2 hover:text-green-500  transition-all ease-in-out duration-200 cursor-pointer`}
                    src={require("../../assets/MusicPlaying.gif")}
                    alt=""
                  />
                ) : (
                  <RiPlayMiniFill
                    onClick={() =>
                      props.songData._id == data_id
                        ? props.changePlayPause(!props.isPlaying)
                        : props.changeTrack(data_id)
                    }
                    className={`${
                      !props.isPlaying &&
                      props.songData._id == data_id &&
                      "text-green-600"
                    }  text-white text-2xl ml-2  hover:text-green-500  transition-all ease-in-out duration-200 cursor-pointer`}
                  />
                )}
                <p
                  className={`flex ml-8 flex-col ${
                    !props.isPlaying &&
                    props.songData._id == data_id &&
                    "text-green-600"
                  }   hover:border-b-2  text-white hover:border-b-[#ffffff60] border-b-2 border-b-transparent transition-all ease-in-out`}
                >
                  {title}{" "}
                  <span className="text-white opacity-60 text-sm ">
                    {singer}
                  </span>
                </p>
              </div>
              <p className="text-white opacity-60 text-sm">03:66</p>{" "}
            </Link>
          </div>
          <div
            style={{
              marginTop: 30,
            }}
            className="flex  w-[100%] flex-col "
          >
            <h4 className="text-white text-2xl font-semibold opacity-90">
              More by {data.singer}
            </h4>
            <div className="flex ">
              {songs
                .filter((data) => data.singer && data.singer == singer)
                .map((data) => {
                  return <SongCard data={data} key={data._id} link="/album/" />;
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    songData: state.songData,
    isPlaying: state.isPlaying,
  };
};

export default connect(mapStateToProps, { changeTrack, changePlayPause })(
  SongDescription
);
